module.exports = __webpack_public_path__ + "static/img/setting.49784334.png";